import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
    routes: [{
            path: '/',
            name: 'login',
            component: () =>
                import ('./views/Login.vue'),
            show: 0,
        },
        {
            path: '/data',
            name: '参赛数据',
            icon: 'el-icon-s-home',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                    path: '/data',
                    component: () =>
                        import ('./views/data/index.vue'),
                    name: '数据统计'
                },
                {
                    path: '/fundinout',
                    component: () =>
                        import ('./views/data/fundInOut.vue'),
                    name: '资金出入'
                }
            ]
        },
        {
            path: '/comments',
            name: '咨询我们',
            icon: 'el-icon-s-comment',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 1,
            children: [
                {
                    path: '/comments',
                    component: () =>
                        import ('./views/comments/consult.vue'),
                    name: '咨询我们'
                }
            ]
        },
        {
            path: '/product',
            name: '参会门票',
            icon: 'el-icon-s-ticket',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 1,
            children: [
                {
                    path: '/product',
                    component: () =>
                        import ('./views/product/index.vue'),
                    name: '参会门票'
                }
            ]
        },
        // {
        //     path: '/signup',
        //     name: '订单管理',
        //     icon: 'el-icon-s-finance',
        //     component: () =>
        //         import ('./views/Home.vue'),
        //     show: 1,
        //     isLeaf: 1,
        //     children: [{
        //         path: '/signup',
        //         component: () =>
        //             import ('./views/signup/index.vue'),
        //         name: '订单管理'
        //     }, ]
        // },
        {
            path: '/player',
            name: '选手管理',
            icon: 'el-icon-user',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 1,
            children: [{
                path: '/player',
                component: () =>
                    import ('./views/player/index.vue'),
                name: '参赛选手'
            }]
        },
        {
            path: '/user',
            name: '用户管理',
            icon: 'el-icon-s-custom',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 1,
            children: [{
                path: '/user',
                component: () =>
                    import ('./views/user/index.vue'),
                name: '用户管理'
            }, ]
        },
        {
            path: '/comments',
            name: '留言管理',
            icon: 'el-icon-tickets',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [
                {
                    path: '/record/comments/list',
                    component: () =>
                        import ('./views/comments/recordComments.vue'),
                    name: '作业留言'
                }
            ]
        },
        {
            path: '/match',
            name: '赛事管理',
            icon: 'el-icon-trophy-1',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                    path: '/match',
                    component: () =>
                        import ('./views/match/index.vue'),
                    name: '赛事管理'
                }, {
                    path: '/group',
                    component: () =>
                        import ('./views/match/group.vue'),
                    name: '赛事分组'
                },
                {
                    path: '/stock',
                    component: () =>
                        import ('./views/match/stock.vue'),
                    name: '股票仓库'
                }
            ]
        },
        {
            path: '/match',
            name: '文章管理',
            icon: 'el-icon-document',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                path: '/championsay',
                component: () =>
                    import ('./views/match/championSay.vue'),
                name: '文章数据'
            },
            {
                path: '/addChampionSay',
                component: () =>
                    import ('./views/match/addChampionSay.vue'),
                name: '新增文章',
            },
            {
                path: '/notice',
                component: () =>
                    import ('./views/match/notice.vue'),
                name: '公告通知'
            },
            {
                path: '/addNotice',
                component: () =>
                    import ('./views/match/addArticle.vue'),
                name: '新增公告',
                hide: 1,
                isLeaf: 1
            },
            ]
        },
        {
            path: '/sys',
            name: '赛方管理',
            icon: 'el-icon-mobile',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                    path: '/supermatch',
                    component: () =>
                        import ('./views/supermatch/supermatch.vue'),
                    name: '赛方管理'
                },
                {
                    path: '/addSuperMatch',
                    component: () =>
                        import ('./views/supermatch/addSuperMatch.vue'),
                    name: '新增赛方'
                }
            ]
        },
        {
            path: '/sys',
            name: '系统管理',
            icon: 'el-icon-mobile',
            component: () =>
                import ('./views/Home.vue'),
            show: 1,
            isLeaf: 0,
            children: [{
                    path: '/sys/version',
                    component: () =>
                        import ('./views/sys/Version.vue'),
                    name: '版本管理'
                }
            ]
        }
    ],
    routes_match:[{
        path: '/',
        name: 'login',
        component: () =>
            import ('./views/Login.vue'),
        show: 0,
    },
    {
        path: '/data',
        name: '参赛数据',
        icon: 'el-icon-s-home',
        component: () =>
            import ('./views/Home.vue'),
        show: 1,
        isLeaf: 0,
        children: [{
                path: '/data',
                component: () =>
                    import ('./views/data/index.vue'),
                name: '数据统计'
            },
            {
                path: '/fundinout',
                component: () =>
                    import ('./views/data/fundInOut.vue'),
                name: '资金出入'
            }
        ]
    },
    {
        path: '/player',
        name: '选手管理',
        icon: 'el-icon-user',
        component: () =>
            import ('./views/Home.vue'),
        show: 1,
        isLeaf: 1,
        children: [{
            path: '/player',
            component: () =>
                import ('./views/player/index.vue'),
            name: '参赛选手'
        }]
    },
    {
        path: '/match',
        name: '赛事管理',
        icon: 'el-icon-trophy-1',
        component: () =>
            import ('./views/Home.vue'),
        show: 1,
        isLeaf: 0,
        children: [{
                path: '/match',
                component: () =>
                    import ('./views/match/index.vue'),
                name: '赛事管理'
            }, {
                path: '/group',
                component: () =>
                    import ('./views/match/group.vue'),
                name: '赛事分组'
            }
          
        ]
    },
    {
        path: '/sys',
        name: '简介管理',
        icon: 'el-icon-mobile',
        component: () =>
            import ('./views/Home.vue'),
        show: 1,
        isLeaf: 0,
        children: [{
                path: '/supermatch',
                component: () =>
                    import ('./views/supermatch/supermatch.vue'),
                name: '简介管理'
            }
        ]
    },
    ],
    routes_article:[{
        path: '/match',
        name: '文章管理',
        icon: 'el-icon-document',
        component: () =>
            import ('./views/Home.vue'),
        show: 1,
        isLeaf: 0,
        children: [{
            path: '/championsay',
            component: () =>
                import ('./views/match/championSay.vue'),
            name: '文章数据'
        },
        {
            path: '/addChampionSay',
            component: () =>
                import ('./views/match/addChampionSay.vue'),
            name: '新增文章',
            isLeaf: 1
        },
        ]
    }],
    routes_message: [{
        path: '/',
        name: 'login',
        component: () =>
            import ('./views/Login.vue'),
        show: 0,
    },
    {
        path: '/data',
        name: '参赛数据',
        icon: 'el-icon-s-home',
        component: () =>
            import ('./views/Home.vue'),
        show: 1,
        isLeaf: 0,
        children: [{
                path: '/data',
                component: () =>
                    import ('./views/data/index.vue'),
                name: '数据统计'
            },
            {
                path: '/fundinout',
                component: () =>
                    import ('./views/data/fundInOut.vue'),
                name: '资金出入'
            }
        ]
    },
    {
        path: '/comments',
        name: '咨询我们',
        icon: 'el-icon-s-comment',
        component: () =>
            import ('./views/Home.vue'),
        show: 1,
        isLeaf: 1,
        children: [
            {
                path: '/comments',
                component: () =>
                    import ('./views/comments/consult.vue'),
                name: '咨询我们'
            }
        ]
    }]
})